import type { IonSegmentCustomEvent } from '@ionic/core';
import { IonLabel, IonSegment, IonSegmentButton, SegmentChangeEventDetail } from '@ionic/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { EntityFormField } from '../../interfaces/forms.interface';

interface Props {
  field: EntityFormField<any>;
  formik: any;
  marginTop?: string;
  widthClass?: string;
  value1: any;
  value2: any;
  label1: string;
  label2: string;
}

export const BSegment = ({
  field,
  formik,
  marginTop = 'margin-t-38',
  widthClass = 'width-300px',
  value1,
  value2,
  label1,
  label2,
}: Props) => {
  const labelStyle = field.labelStyle || '';
  const formValue = formik.values?.[field.name];
  const { t } = useTranslation();

  const getTitle = useCallback(() => {
    let mainBody = t(`FORMS.${field.label}`);
    if (field.required) {
      mainBody = t(`FORMS.${field.label}`) + ' *';
    }

    return <div className={`padding-b-10 padding-t-6 padding-l-12 ${labelStyle}`}>{mainBody}</div>;
  }, [field.label, field.required, labelStyle, t]);

  const onChange = useCallback(
    (e: IonSegmentCustomEvent<SegmentChangeEventDetail>) => {
      formik.setFieldValue(field.name, e.detail.value);
    },
    [field.name, formik],
  );

  return (
    <div className="positionRelative">
      {getTitle()}
      <div key={field?.name} className={`flex-center-start-column-nowrap ${widthClass}`}>
        <IonSegment value={formValue} mode="ios" onIonChange={onChange}>
          <IonSegmentButton value={value1}>
            <IonLabel>{t(`FILTERS.${label1}`)}</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={value2}>
            <IonLabel>{t(`FILTERS.${label2}`)}</IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </div>
    </div>
  );
};
